import { render, staticRenderFns } from "./AliTaobaoVerifyNum.vue?vue&type=template&id=05895a16&scoped=true&"
import script from "./AliTaobaoVerifyNum.vue?vue&type=script&lang=js&"
export * from "./AliTaobaoVerifyNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05895a16",
  null
  
)

export default component.exports